import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chart",
  "use": "icon-chart-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chart\">\n  <path d=\"M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z\" fill=\"currentColor\" p-id=\"4427\" />\n  <path d=\"M305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-138.3 108.4 108.4c3.1 3.1 8.2 3.1 11.3 0l235.9-235.9c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6c-3.1-3.1-8.2-3.1-11.3 0l-196.6 196.6-108.4-108.4c-3.1-3.1-8.1-3.1-11.3 0L266.2 586.7c-3.1 3.1-3.1 8.2 0 11.3l39.6 39.7z\" fill=\"currentColor\" p-id=\"4428\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/chart.svg
// module id = RjYk
// module chunks = 117